export const allButFirstChild = `:nth-child(n + 2)`;
export const allButLastChild = `:nth-last-child(n + 2)`;
